// extracted by mini-css-extract-plugin
export var menuIcon = "_t4-0";
export var menuIconInline = "_t4-1";